import { render, staticRenderFns } from "./NedbankAuthCallback.vue?vue&type=template&id=37bea666&scoped=true"
import script from "./NedbankAuthCallback.vue?vue&type=script&lang=js"
export * from "./NedbankAuthCallback.vue?vue&type=script&lang=js"
import style0 from "./NedbankAuthCallback.vue?vue&type=style&index=0&id=37bea666&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bea666",
  null
  
)

export default component.exports